import React, { useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import AccessKeySection from "../AccessKeySection";
import AccessSystemSection from "../AccessSystemSection";

const AccessKeysPage = () => {
  const [activeTab, setActiveTab] = useState("access_keys");

  return (
    <>
      <Tabs activeKey={activeTab} onSelect={(tab) => setActiveTab(tab)}>
        <Tab title={"Zutrittsschlüssel"} eventKey={"access_keys"}>
          {activeTab === "access_keys" && <AccessKeySection />}
        </Tab>
        <Tab title="Geräte" eventKey={"access_systems"}>
          {activeTab === "access_systems" && <AccessSystemSection />}
        </Tab>
      </Tabs>
    </>
  );
};

export default AccessKeysPage;
